import { render, staticRenderFns } from "./ModuleInbox.vue?vue&type=template&id=2e222d1a&scoped=true&lang=pug&"
import script from "./ModuleInbox.vue?vue&type=script&lang=js&"
export * from "./ModuleInbox.vue?vue&type=script&lang=js&"
import style0 from "./ModuleInbox.vue?vue&type=style&index=0&id=2e222d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e222d1a",
  null
  
)

export default component.exports